import type { Conversation } from '@auw/workspace-utils';

export function collectDescendantConversationIds(
  conversations: Record<string, Conversation>,
  rootId: string,
): string[] {
  const descendants: string[] = [];
  const stack = [rootId];
  while (stack.length > 0) {
    const current = stack.pop()!;
    for (const [id, conversation] of Object.entries(conversations)) {
      if (conversation.workspaceParentId === current && !descendants.includes(id)) {
        descendants.push(id);
        stack.push(id);
      }
    }
  }
  return descendants;
}

export function isDescendantConversation(
  conversations: Record<string, Conversation>,
  nodeId: string,
  ancestorId: string,
): boolean {
  let current = conversations[nodeId];
  const visited = new Set<string>();
  while (current?.workspaceParentId) {
    const parentId = current.workspaceParentId;
    if (parentId === ancestorId) return true;
    if (visited.has(parentId)) break;
    visited.add(parentId);
    current = conversations[parentId];
  }
  return false;
}

export function normalizeWorkspaceOrder(
  workspaceOrder: string[],
  conversationOrder: string[],
  conversations: Record<string, Conversation>,
): string[] {
  const validIds = new Set(Object.keys(conversations));
  const seen = new Set<string>();
  const normalized: string[] = [];

  for (const id of workspaceOrder) {
    if (validIds.has(id) && !seen.has(id)) {
      normalized.push(id);
      seen.add(id);
    }
  }
  for (const id of conversationOrder) {
    if (validIds.has(id) && !seen.has(id)) {
      normalized.push(id);
      seen.add(id);
    }
  }
  for (const id of Object.keys(conversations)) {
    if (!seen.has(id)) {
      normalized.push(id);
      seen.add(id);
    }
  }
  return normalized;
}
